export const getImageUrl = (image) => {
  return `url(${getImagePath(image)})`;
}

export const getImagePath = (image) => (
  (image && !!image.childImageSharp) ?
    image.childImageSharp.fluid.src :
    image
)
